import React, { useState } from 'react';
import styled from 'styled-components';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const CardContainer = styled.div`
  border: 1px solid #dee2e6;
  padding: 15px;
  border-radius: 6px;
`;

const SubscriptionSummary = styled.div`
  background: #f8f9fa;
  border-radius: 6px;
  padding: 20px;
  margin-bottom: 20px;
`;

const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  
  &:last-child {
    margin-bottom: 0;
    padding-top: 10px;
    border-top: 1px solid #dee2e6;
    font-weight: 600;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 20px;
`;

const Button = styled.button`
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  flex: 1;

  ${props => props.primary ? `
    background: #0062cc;
    color: white;
    border: none;

    &:hover {
      background: #0056b3;
    }
  ` : `
    background: white;
    color: #0062cc;
    border: 1px solid #0062cc;

    &:hover {
      background: #f8f9fa;
    }
  `}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const Error = styled.div`
  color: #dc3545;
  font-size: 14px;
  margin-top: 10px;
`;

const cardElementOptions = {
  style: {
    base: {
      fontSize: '16px',
      color: '#333',
      '::placeholder': {
        color: '#aab7c4'
      }
    },
    invalid: {
      color: '#dc3545',
      iconColor: '#dc3545'
    }
  }
};

const PaymentForm = ({ tier, onSuccess, onCancel }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);

    if (!stripe || !elements) {
      return;
    }

    setLoading(true);

    try {
      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: 'card',
        card: elements.getElement(CardElement)
      });

      if (error) {
        throw error;
      }

      await onSuccess(paymentMethod.id);
    } catch (err) {
      setError(err.message || 'An error occurred while processing your payment');
      setLoading(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <SubscriptionSummary>
        <SummaryRow>
          <span>{tier.name} Plan</span>
          <span>${tier.monthly_price}/month</span>
        </SummaryRow>
        <SummaryRow>
          <span>Property Limit</span>
          <span>{tier.property_limit} properties</span>
        </SummaryRow>
        <SummaryRow>
          <span>Total Due Today</span>
          <span>${tier.monthly_price}</span>
        </SummaryRow>
      </SubscriptionSummary>

      <div>
        <label>Card Details</label>
        <CardContainer>
          <CardElement options={cardElementOptions} />
        </CardContainer>
      </div>

      {error && <Error>{error}</Error>}

      <ButtonGroup>
        <Button type="button" onClick={onCancel}>
          Cancel
        </Button>
        <Button primary type="submit" disabled={loading || !stripe}>
          {loading ? 'Processing...' : 'Subscribe Now'}
        </Button>
      </ButtonGroup>
    </Form>
  );
};

export default PaymentForm;